import { authAPI } from "../config";

export const postChatList = (typeName?: string, form?: any) => {
  return authAPI.post(`/list/${typeName || "event"}`, form);
};

export const postChatGoogleList = (keyword?: string) => {
  return authAPI.post(`/google`, { keyword: keyword });
};

//트립어드바이저
export const postChatTripList = (keyword?: string) => {
  return authAPI.post(`/trip-list`, { keyword: keyword });
};

export const getChatTripInfo = (id: string) => {
  return authAPI.get(`/trip-link?id=${id}`);
};
